import React from 'react'
import Honeybadger from 'honeybadger-js'

// GraphQL
import { useMutation } from '@apollo/client'

import { scrollToTop } from 'components/shared/ScrollToTop'

// business logic
import updateCache from './updateCache'

const withMutation = WrappedComponent => {
  return props => {
    const {
      entity, // via parent component
      fieldGroup, // via parent component
      mutation, // via parent component
      mutationName, // via parent component
      successMessage, // via parent component
      setModal, // via redux actions
      setErrorMessage, // via Redux actions
      notify // via redux actions
    } = props

    // see also `onMutationError` via `withFormResults`
    const handleMutationError = error => {
      notify({
        variant: 'error',
        autoHide: false,
        message: 'Something went wrong. Please try again or refresh.'
      })
      Honeybadger.notify(error, {
        name: 'DeleteEntityError',
        context: { entity }
      })
    }

    const handleMutationCompleted = data => {
      if (data && data[mutationName]) {
        // display any mutation errors
        if (data[mutationName].errors && data[mutationName].errors.length > 0) {
          const message = data[mutationName].errors
            .map(error => error.message)
            .join(', ')
          setErrorMessage(message)
          setModal({ open: false })
          scrollToTop()
        } else {
          // clear any previous error messages
          setErrorMessage(null)
          notify({ message: successMessage })
          setModal({ open: false })
        }
      }
    }

    // setup GraphQL mutation
    const [deleteEntity, { loading }] = useMutation(mutation, {
      update: updateCache({ entity, fieldGroup, mutationName }),
      onError: handleMutationError,
      onCompleted: handleMutationCompleted
    })

    return (
      <WrappedComponent
        loading={loading}
        deleteEntity={deleteEntity}
        {...props}
      />
    )
  }
}

export default withMutation
